import { useEffect } from "react";
import { useNavigate } from "react-router";
import { paths } from "../../shared/configs/paths";
import { runMock } from "./mock";

export const MockPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    runMock();
    // jump to main UI after we seed stores
    navigate(paths.home, { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center text-gray-200">
      <div className="rounded-xl border border-gray-800 bg-gray-900/40 px-5 py-4">
        <div className="text-sm text-gray-300">Mocking device…</div>
        <div className="text-xs text-gray-500 mt-1">Redirecting to the app UI.</div>
      </div>
    </div>
  );
};


